import { render, staticRenderFns } from "./IconNewsUpdate.vue?vue&type=template&id=2e213abe"
import script from "./IconNewsUpdate.vue?vue&type=script&lang=js"
export * from "./IconNewsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports